export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7671.853eb182.jpg";